var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-banner",on:{"click":_vm.goToNotice}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v(" 고객 감사 "),_c('span',{staticClass:"text-primary"},[_vm._v(" 할증 요금 ZERO ")]),_vm._v(" 이벤트! ")])
}]

export { render, staticRenderFns }